import { render } from "./OngoingVisit.vue?vue&type=template&id=a8f7a666&scoped=true"
import script from "./OngoingVisit.vue?vue&type=script&lang=js"
export * from "./OngoingVisit.vue?vue&type=script&lang=js"

import "./OngoingVisit.vue?vue&type=style&index=0&id=a8f7a666&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8f7a666"]])

export default __exports__